import lobData from '../../assets/lob-cards.json';

export interface FusionRecipe {
  fusionId: number;
  fusionName: string;
  materialNames: string[];
  materialIds: number[];
  atk: number;
  def: number;
  level: number;
}

const allCards = (lobData as any).data as any[];

const fusionRecipes: FusionRecipe[] = [];

function parseFusionMaterials(desc: string): string[] {
  const matches = desc.match(/"([^"]+)"/g);
  if (!matches) return [];
  return matches.map(m => m.split('"').join(''));
}

function buildFusionRecipes(): void {
  if (fusionRecipes.length > 0) return;

  const fusionMonsters = allCards.filter((c: any) => c.frameType === 'fusion');

  for (const fusion of fusionMonsters) {
    const materialNames = parseFusionMaterials(fusion.desc);
    const materialIds = materialNames.map(name => {
      const card = allCards.find((c: any) => c.name === name);
      return card ? card.id : -1;
    }).filter((id: number) => id !== -1);

    if (materialIds.length >= 2) {
      fusionRecipes.push({
        fusionId: fusion.id,
        fusionName: fusion.name,
        materialNames,
        materialIds,
        atk: fusion.atk ?? 0,
        def: fusion.def ?? 0,
        level: fusion.level ?? 0,
      });
    }
  }
}

buildFusionRecipes();

export function getFusionRecipes(): FusionRecipe[] {
  return fusionRecipes;
}

export function getFusionRecipeById(fusionId: number): FusionRecipe | undefined {
  return fusionRecipes.find(r => r.fusionId === fusionId);
}

/**
 * Given a list of available card IDs (from hand + field), returns all fusion recipes
 * that can be completed with those cards, paired with a fusion monster ID in the extra deck.
 */
export function getAvailableFusions(
  availableCardIds: number[],
  extraDeckIds: number[]
): FusionRecipe[] {
  return fusionRecipes.filter(recipe => {
    if (!extraDeckIds.includes(recipe.fusionId)) return false;

    const remaining = [...availableCardIds];
    for (const matId of recipe.materialIds) {
      const idx = remaining.indexOf(matId);
      if (idx === -1) return false;
      remaining.splice(idx, 1);
    }
    return true;
  });
}
